import {
  OnboardingFlowNodeType,
  getNewFlowStarterConfig,
  OnboardingFlowNode,
  OnboardingFlowTransition,
  ConditionType,
  IOnboardingFlow,
  OnboardingStepAttributeKey,
  getOnboardingStepAttributeMap,
} from '@scale/shared/onboardingControlPanel';

// steps that operators shouldn't be able to configure edges to or from
export const UNCONNECTABLE_STEP_TYPES_NAMES: string[] = [
  'Signup',
  'Phone Verification',
  'Persona',
  'Skill Selection',
  'Persona Failed',
  'Resume Collection',
  'General Reasoning Assessment',
  'General Reasoning Failed',
];

const newFlowStarter = getNewFlowStarterConfig();

export const isNodeUneditable = (
  node?: OnboardingFlowNode,
  flow?: IOnboardingFlow | null,
): boolean => {
  const editableNodeMap = getOnboardingStepAttributeMap(OnboardingStepAttributeKey.Editable);
  return !!(
    node &&
    node.name !== 'Custom Node' &&
    (node.name === 'Signup' ||
      (!flow?.freeEdit &&
        ((node.type === OnboardingFlowNodeType.Step && !editableNodeMap[node.stepType]) ||
          !!newFlowStarter.nodes.some(starterNode => starterNode.name === node.name))))
  );
};

export const isTransitionUneditable = (
  edge?: OnboardingFlowTransition,
  flow?: IOnboardingFlow | null,
): boolean => {
  if (edge?.conditions && edge?.conditions[0]?.type === ConditionType.LoadBalancer) {
    return true;
  }

  return !!(
    edge &&
    edge.name !== 'Join Slack -> Custom Node' &&
    !flow?.freeEdit &&
    !!newFlowStarter.edges.some(starterEdge => starterEdge.name === edge.name)
  );
};

export const isTerminusNode = (node?: OnboardingFlowNode): boolean => {
  return !!(node && node.type === OnboardingFlowNodeType.Terminus);
};
